import './Loading.css';

import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function Waiting({ waitingState, leaveCall }) {
  const { t } = useTranslation();
  const renderApp = () => {
    //画像をクリック
    const reload = async (e) => {
      window.location.reload();
    };

    return (
      <>
        <div
          id="loadingBack"
          style={{
            visibility: waitingState ? 'visible' : 'hidden',
            opacity: waitingState ? 1 : 0,
          }}>
          <div className="profile-main-loader">
            <div id="waitingWrap">
              <div className="waitingText">
                {t('haircheck.Please wait until the host starts the meeting')}
              </div>
              <button className="waitingCancelButton" onClick={reload}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  return renderApp();
}
